import { interpolate, type Labels } from "./labels";

const APPEARANCE = ["body", "hair", "general", "special"];
const PERSONALITY = ["self", "others", "rest", "special"];

const lower = (word: string) => word.trim().toLocaleLowerCase();
const upperFirst = (text: string) => text.charAt(0).toLocaleUpperCase() + text.slice(1);

// "Melina é franzino, de cabelos longos e moreno." (a hair word that is an adjective, "careca", takes no "de"). The words are the ones typed in the Oficina,
// so a word the table wrote in the masculine stays there.
export function appearanceSentence(name: string, words: Record<string, string>, labels: Labels): string {
	const bare = labels.details.hair_adjectives.split(",").map(lower);
	const traits = APPEARANCE.filter((key) => words[key]?.trim()).map((key) => {
		const word = lower(words[key]);
		return key === "hair" && !bare.includes(word) ? interpolate(labels.details.hair, { value: word }) : word;
	});
	if (traits.length === 0) return "";
	const list = traits.length > 1 ? `${traits.slice(0, -1).join(", ")} ${labels.details.and} ${traits[traits.length - 1]}` : traits[0];
	return interpolate(labels.details.appearance, { name, traits: list });
}

// "Consigo mesmo é indeciso; com os outros, excêntrico; com o resto do mundo, idealista."
export function personalitySentence(words: Record<string, string>, labels: Labels): string {
	const clauses = PERSONALITY.filter((key) => words[key]?.trim()).map((key) => interpolate(labels.details[key], { value: lower(words[key]) }));
	return clauses.length > 0 ? `${upperFirst(clauses.join("; "))}.` : "";
}
